import React from "react";
import  { withStyles } from '@material-ui/core/styles';
import Tooltip from '../../common/StyledToolTip';
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { formatDateTime } from "../gridUtilities";
import RevertRenderer from "../../modules/IBPlanning/ShipmentsView/RevertRenderer";

const styles = theme => ({
    arrivedShipment:{
        fontStyle:"italic",
        opacity:"0.65",
        fontWeight:400
    },
    alignMiddle:{
        verticalAlign:"middle",
    },
    computedIBETA:{
        fontSize:"15px"
    }
});

const IBETARenderer = (params) => {
    const {actualArrivalTime, isComputedIbeta} = params.data;
    const {classes} = params;
    if(actualArrivalTime){
        return <span className={classes.arrivedShipment}> Arrived </span>
    }
    else if(!actualArrivalTime && isComputedIbeta){
        return (
          <>
            <span className={classes.alignMiddle}>{params.valueFormatted} </span>
            <Tooltip title="RouteMAX ETA">
              <InfoOutlinedIcon
                className={`${classes.computedIBETA} ${classes.alignMiddle}`}
                color="primary"
              />
            </Tooltip>
            <RevertRenderer
              originalValue={formatDateTime({ value: params.data.originalShipmentEtaDateTime })}
              gridParams={params}
            />
          </>
        );
    }
    return (
      <div className="gridCell-centerAlign">
        <span>{params.valueFormatted}</span>
        <RevertRenderer
          originalValue={formatDateTime({ value: params.data.originalShipmentEtaDateTime })}
          gridParams={params}
        />
      </div>
    );
}

export default withStyles(styles)(IBETARenderer);